
import { addEvaluateTag, deleteEvaluateTag, getEvaluateTagList, getLevelList, modifyEvaluateTag, setEvaluate, setLevel, getWechatConfig } from '@/api/templateEvaluate';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '../../store/modules/user';

@Component({
  name: 'SettingTemplateEvaluateTags',
  components: {

  }
})
export default class extends Vue { // 东改
  private activeName = 'first'
  private colors = ['#45CCF0', '#45CCF0', '#45CCF0']

  private evaluationType = '1'
  private rulesData: any = []
  private ruleTagsTableData: any = []
  private selectTagsList: any = []
  private selectEngTagsList: any = []
  private selectDeptTagsList: any = []
  private dialogTagsVisible = false
  private moreLoading = false
  private moreLoadingLeft = false
  private moreLoadingRight = false
  private listQuery: any = {
    pageCurrent: 1,
    pageSize: 10,
    order: []
  }

  private rulesType = '1'
  private tagsTableData: any = []
  private tableLevelData: any = []
  private selectLevelEng: any = []
  private selectLevelDep: any = []
  private dialogSetLevel = false

  // 分页处理
  private tagsListQuery = {
    name: '',
    page: 1,
    size: 8,
    total: 0
  }
  // 优化 关于参数的拼接
  private tagParams: any = {
    user_id: UserModule.getUserId,
    company_id: UserModule.getCompanyId,
    name: '',
    page: this.tagsListQuery.page,
    size: this.tagsListQuery.size
  };
  private handleCurrentChange(page: number) {
    this.tagParams.page = page;
    this.getEvaluateTags();
  }
  private handleSizeChange(size: number) {
    this.tagParams.size = size;
    this.getEvaluateTags();
  }
  private searchTagsTable() {
    this.tagParams.page = 1
    this.tagParams.name = this.tagsListQuery.name;
    this.getEvaluateTags();
  }
  private emptySearchTagsTable() {
    this.tagParams.page = 1;
    this.tagParams.name = '';
    this.tagsListQuery.name = '';
    this.getEvaluateTags();
  }
  // Life circle
  private created() {
    this.getEvaluateLevels();
    this.getEvaluateTags();
    // this.getWechat();
  }
  // test
  private getWechat() {
    let params: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId
    };
    getWechatConfig(params).then(res => {
    }).catch((err: any) => {
      this.showErrorMsg(err.msg);
    });
  }
  /**
   * 规则
  */
  // 规则-列表
  private getEvaluateLevels() {
    let params: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId
    };
    getLevelList(params).then(res => {
      if (res.data) {
        this.rulesData = res.data;
      }
    }).catch((err: any) => {
      this.showErrorMsg(err.msg);
    });
  }
  // 规则-设置
  private selectedLevel = '';
  private setTags(val: any) {
    this.listQuery.order = [];
    for (const item of val.dept_company_tags_list) {
      this.listQuery.order.push((item).id);
    }
    for (const item of val.engineer_tags_list) {
      this.listQuery.order.push(item.id);
    }
    // 默认先展示 评价工程师
    this.evaluationType = '1';
    this.selectedLevel = val.level;
    this.listQuery.pageCurrent = 1;
    this.getTagsForSetLevel();
  }
  private getTagsForSetLevel() {
    let params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      order: this.listQuery.order,
      page: this.listQuery.pageCurrent,
      size: this.listQuery.pageSize
    };
    getEvaluateTagList(params).then(res => {
      this.dialogTagsVisible = true;
      if (res.data && res.data.page_count > 1 && res.data.page_current < res.data.page_count) {
        this.moreLoading = true;
      } else {
        this.moreLoading = false;
      }
      if (res.data && res.data.list) {
        this.moreLoadingLeft = false;
        this.moreLoadingRight = false;
        if (this.listQuery.pageCurrent === 1) {
          this.ruleTagsTableData = res.data.list;
        } else {
          this.ruleTagsTableData = this.ruleTagsTableData.concat(res.data.list);
        }

        // 注意初始设置
        this.selectEngTagsList = [];
        this.selectDeptTagsList = [];
        // 根据level判断当前选中
        for (const item of this.ruleTagsTableData) {
          if (item.engineer_levels.split(',').includes(this.selectedLevel)) {
            this.selectEngTagsList.push(item.id);
          }
          if (item.dept_company_levels.split(',').includes(this.selectedLevel)) {
            this.selectDeptTagsList.push(item.id);
          }
        }
      } else {
        this.ruleTagsTableData = [];
      }
    }).catch((err: any) => {
      this.showErrorMsg(err.msg);
    });
  }
  private moreDataLeft() {
    this.moreLoadingLeft = true;
    this.listQuery.pageCurrent++;
    this.getTagsForSetLevel();
  }
  private moreDataRight() { // 评价部门/公司  加载更多按钮
    this.moreLoadingRight = true;
    this.listQuery.pageCurrent++;
    this.getTagsForSetLevel();
  }

  // 选中评价标签 单选或多选
  private selectTagsChange(val: any) {
    this.selectTagsList = val;
    if (parseInt(this.evaluationType) === 1) { // 评价工程师
      this.selectEngTagsList = this.selectTagsList;
    } else {
      this.selectDeptTagsList = this.selectTagsList;
    }
    if (this.selectTagsList.length >= 8) {
      this.$confirm('最多可设置8个标签!', '提示', {
        confirmButtonText: '确定',
        showCancelButton: false,
        type: 'warning'
      }).catch(() => {});
    }
  }
  private cancelSetTag() {
    this.dialogTagsVisible = false;
  }
  private clickToSetTag() {
    let params: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      level: this.selectedLevel,
      engineer_tags: this.selectEngTagsList.join(','),
      dept_company_tags: this.selectDeptTagsList.join(',')
    };
    setEvaluate(params).then(res => {
      this.getEvaluateLevels();
      this.getEvaluateTags();
      this.dialogTagsVisible = false;
      this.showSuccessMsg('设置成功');
    }).catch((err: any) => {
      this.showErrorMsg(err.msg);
    });
  }
  /**
   * 评价标签
  */
  private multiTags: any = [];
  // 评价标签列表
  private getEvaluateTags() {
    getEvaluateTagList(this.tagParams).then(res => {
      if (res.data && res.data.list) {
        this.tagsTableData = res.data.list;
        this.tagsListQuery.total = parseInt(res.data.count);
        this.tagsListQuery.page = parseInt(res.data.page_current);
      } else {
        this.tagsTableData = [];
        this.tagsListQuery.total = 0;
        this.tagsListQuery.page = 1;
      }
    }).catch((err: any) => {
      this.showErrorMsg(err.msg);
      this.tagsListQuery.total = 0;
      this.tagsListQuery.page = 1;
    });
  }
  // 新增评价标签
  private addTags() {
    this.$prompt('名称', '新增标签', {
      confirmButtonText: '完成',
      cancelButtonText: '取消',
      inputPlaceholder: '请输入1-8个字标签名称',
      inputPattern: /^.{1,8}$/,
      inputErrorMessage: '请输入1-8个字标签名称'
    }).then(({ value }: any) => {
      this.addEvaluateTag(value);
    }).catch(() => {});
  }
  private addEvaluateTag(val : any) {
    let params: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      name: val
    };
    addEvaluateTag(params).then(res => {
      this.getEvaluateTags();
      this.showSuccessMsg('添加成功');
    }).catch((err: any) => {
      this.showErrorMsg(err.msg);
    });
  }
  // 删除单个评价标签
  private deleteTags(val: any) {
    this.$confirm('确认删除?', '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'info'
    }).then(() => {
      this.deleteEvaluateTag(val);
    }).catch(() => {});
  }
  // 批量删除评价标签
  private deleteGroupTags() {
    if (this.multiTags.length === 0) {
      this.showErrorMsg('请选择要批量删除的标签');
      return;
    }
    let tags: any = [];
    for (const item of this.multiTags) {
      tags.push(item.id);
    }
    this.$confirm('确认删除?', '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'info'
    }).then(() => {
      this.deleteEvaluateTag(tags.join(','));
    }).catch(() => {});
  }
  private deleteEvaluateTag(val: any) {
    let params: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      tags_id: val
    };
    deleteEvaluateTag(params).then(res => {
      this.getEvaluateTags();
      this.showSuccessMsg('删除成功');
    }).catch((err: any) => {
      this.showErrorMsg(err.msg);
    });
  }
  // 编辑评价标签
  private editTags(val: any) {
    this.$prompt('名称', '编辑标签', {
      confirmButtonText: '完成',
      cancelButtonText: '取消',
      inputValue: val.name,
      inputPattern: /^.{1,8}$/,
      inputErrorMessage: '请输入1-8个字标签名称'
    }).then(({ value }: any) => {
      this.modifyEvaluateTag(val.id, value);
    }).catch(() => {
    });
  }
  private modifyEvaluateTag(id: any, name: any) {
    let params: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      tags_id: id,
      name: name
    };
    modifyEvaluateTag(params).then(res => {
      this.getEvaluateTags();
    }).catch((err: any) => {
      this.showErrorMsg(err.msg);
    });
  }
  // 设置单个评价标签
  private selectedTagsID = '';
  private setRule(val: any) {
    this.rulesType = '1';
    this.dialogSetLevel = true;
    this.tableLevelData.splice(0, this.tableLevelData.length);
    for (let i = 0; i < 5; i++) {
      let item: any = {};
      item.number = i + 1 + '';
      item.id = i + 1 + '';
      this.tableLevelData.push(item);
    }
    this.selectedTagsID = val.id;
    this.selectLevelEng = val.engineer_levels.split(',');
    this.selectLevelDep = val.dept_company_levels.split(',');
  }
  // 批量设置评价标签
  private setGroupRule() {
    if (this.multiTags.length === 0) {
      this.showErrorMsg('请选择要批量设置的标签');
      return;
    }
    this.rulesType = '1';
    this.dialogSetLevel = true;
    this.tableLevelData.splice(0, this.tableLevelData.length);
    for (let i = 0; i < 5; i++) {
      let item: any = {};
      item.number = i + 1 + '';
      item.id = i + 1 + '';
      this.tableLevelData.push(item);
    }
    let tags = [];
    for (const item of this.multiTags) {
      tags.push(item.id);
    }
    this.selectedTagsID = tags.join(',');
    this.selectLevelEng = [];
    this.selectLevelDep = [];
  }
  // 选中规则 可单选或多选
  private handleTagsLevelChange(val: any) {
  }
  private clickToSetLevel() {
    this.setLevel();
  }
  private cancelSetLevel() {
    this.dialogSetLevel = false;
  }
  private setLevel() {
    let params: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      tags_id: this.selectedTagsID,
      engineer_level: this.selectLevelEng.join(','),
      dept_company_level: this.selectLevelDep.join(',')
    };
    setLevel(params).then(res => {
      this.getEvaluateTags();
      this.dialogSetLevel = false;
      this.showSuccessMsg('设置成功');
    }).catch((err: any) => {
      this.showErrorMsg(err.msg);
    });
  }
  // 选中评价标签 可单选或多选
  private handleSelectionChange(val: any) {
    this.multiTags = val;
  }
  // hud
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: 'notification-center',
      type: 'success'
    });
  }
}
